import {GetAllModelationsParams} from '@cmp/shared/models/api.model';
import {ModelationList} from '@generated/models';
import {ofType, unionize, UnionOf} from 'unionize';

export const ModelationsActions = unionize({
  SetModelations: ofType<ModelationList[]>(),
  SetParams: ofType<GetAllModelationsParams>(),
  SetTotalCount: ofType<number>(),
}, {tag: 'type', value: 'payload'});

export type ModelationsAction = UnionOf<typeof ModelationsActions>;
